export enum GoalInfoType {
  'NONE' = 'NONE',
  'IS_FROM' = 'IS_FROM',
  'IS_TO' = 'IS_TO',
}
